/** Deterministic colour assignment so each child always gets the same
 *  lane colour in The Nest, without any per-family configuration. */
export const CHILD_COLOR_TOKENS = ['fern', 'moana', 'kowhai', 'kereru'];

export function assignChildColor(childName) {
  let hash = 0;
  for (let i = 0; i < childName.length; i++) {
    hash = (hash * 31 + childName.charCodeAt(i)) >>> 0;
  }
  return CHILD_COLOR_TOKENS[hash % CHILD_COLOR_TOKENS.length];
}
